export enum REQUESTER_TYPE {
  CUSTOMER = 'CUSTOMER',
  STORE = 'STORE',
  NONE = '',
}

export enum REQUEST_TYPE {
  TO_COLLECT_AT_CUSTOMER = 'TO_COLLECT_AT_CUSTOMER',
  CANCEL_OR_REFUND_TO_CUSTOMER = 'CANCEL_OR_REFUND_TO_CUSTOMER',
  NONE = '',
}

export enum COLLECT_TYPE {
  EXCHANGE = 'EXCHANGE',
  RETURN = 'RETURN',
  NONE = '',
}

export enum RETURN_TYPE {
  TOTAL = 'TOTAL',
  PARTIAL = 'PARTIAL',
  NONE = '',
}

export enum EXCHANGE_REASON {
  SIZE = 'SIZE',
  DEFECT_OR_DAMAGE = 'DEFECT_OR_DAMAGE',
  DIVERGENT_OF_WEBSITE = 'DIVERGENT_OF_WEBSITE',
  ABANDONMENT = 'ABANDONMENT',
  UNSATISFIED = 'UNSATISFIED',
  STORE_OUT_OF_STOCK = 'STORE_OUT_OF_STOCK',
  STORE_SENT_WRONG_PRODUCT = 'STORE_SENT_WRONG_PRODUCT',
  OTHERS = 'OTHERS',
  NONE = '',
}

interface Requester {
  name: string;
  email: string;
  phone: string | null;
}

export interface ExchangeReturnFormData {
  status: 'NEW';
  subject: string;
  description: string;
  requester: Requester;
  uploads: string[] | null;
  storeCode: string;
  requestType: REQUEST_TYPE;
  collectType: COLLECT_TYPE | null;
  orderCodes: string;
  requesterType: REQUESTER_TYPE;
  returnType: RETURN_TYPE;
  reason: EXCHANGE_REASON;
  skus: string;
  note: string;
}

export interface PostFormResponse {
  ticketId: string;
  status: string;
}
